import { IUserInfo, LoginForm } from "../models/user";
import configServices from "../utils/configServices";
export interface ILoginResponse {
  data: IUserInfo
  access_token: string,
  expiresIn: number,
  statusCode: number,
  tokenType: string,
} 
export const login = async (param: LoginForm) => {
  // API có StaticTokenAuthorize: trước khi có JWT phải gửi STATIC_API_TOKEN
  // (getToken() fallback khi localStorage chưa có token)
  const response = await configServices.postService<ILoginResponse>(
    "auth/login",
    { ...param, isAdmin: true, deviceType: "Web" },
    true,
    false
  );
  return response;
};

export const logOut = async () => {
  const response = await configServices.postService<any>(
    "auth/logout",
    null,
    true,
    false
  );
  return response;
};

export const getUserInfo = async (id: number) => {
  const response = await configServices.getService<IUserInfo>(
    `user/${id}`,
    null,
    null,
    true
  );
  return response;
};
